// src/api/apiBase.js

const hostname = window.location.hostname;

let API_BASE = "";

if (hostname.includes("localhost")) {
  API_BASE = "http://localhost:8080";
}
else if (
  hostname.includes("staging.measuresmart.ai") ||
  hostname.includes("azurestaticapps")
) {
  API_BASE = "https://api-staging.measuresmart.ai";
}
else {
  API_BASE = "https://api.measuresmart.ai";
}

console.log("Hostname:", hostname);
console.log("API_BASE selected:", API_BASE);

export default API_BASE;
